import TAO_KOE from '../libs/_TAO_KOE';
import TaoReady from '../libs/Ready.js';
import { showError } from '../libs/Error';

class FriendinviteForm {
	constructor( containerEl ) {
		this.containerEl = containerEl;
		this.formEl = this.containerEl.querySelector( 'form.friendinvite' );

		this.containerEl.addEventListener( 'click', ( ev ) => this.onClick( ev ) );
		this.formEl.addEventListener( 'submit', ( ev ) => this.onSubmit( ev ) );

		const inputEl = this.formEl.querySelector( 'input[type=email]' );
		inputEl.addEventListener( 'invalid', ( ev ) => {
			ev.preventDefault();
			const messageEl = this.formEl.querySelector( '#invalid-email' );
			showError( inputEl, messageEl.innerHTML );
		} );
	}

	onClick( ev ) {
		const shareButtonEl = ev.target.closest( '.friendinvite_code_share_button .en_button' );
		if ( shareButtonEl ) {
			if ( shareButtonEl.classList.contains( 'en_js_open_popup' ) ) {
				return;
			}
			ev.preventDefault();
			this.openSharer();
		}
	}

	openSharer() {
		const code = this.containerEl.dataset.code;
		if ( navigator.share ) {
			const shareUrl = new URL( '/shop/?exclusivevoucher=' + code, TAO_KOE.MenuDomain || document.location.href );

			const settings = {
				title: 'Gutscheincode teilen',
				text: 'Hallo,\n\nich habe eben beim Onlineshop von Kastner & Öhler eingekauft.\nMit dem folgenden Link sparst du -10% bei deinem nächsten Einkauf. \n\n Alternativ kannst du auch diesen Gutscheincode direkt eintragen: ' + code,
				url: shareUrl.toString(),
			};

			navigator.share( settings ).catch( console.error ); // eslint-disable-line no-console
		} else {
			// Fallback.
			const EN_KO = window.EN_KO || {};
			const buttonEl = this.containerEl.querySelector( '.friendinvite_code_share_button .en_button' );
			EN_KO.functions.open_popup( buttonEl.getAttribute( 'href' ) );
		}
	}

	onSubmit( ev ) {
		ev.preventDefault();

		// Ordered Data.
		const orderData = window.ACL_ORDER_DATA;

		const emailInputEl = this.formEl.querySelector( 'input[type=email]' );
		const tokenInputEl = this.formEl.querySelector( 'input[name="stoken"]' );
		const orderInputEl = this.formEl.querySelector( 'input[name="ord"]' );
		[ tokenInputEl.value, orderInputEl.value ] = [ window._stoken || orderData?._stoken, orderData?.orderId ];

		TAO_KOE.sendFormElement( this.formEl ).then( ( response ) => {
			if ( 'error' === response?.status ) {
				return Promise.reject( response );
			}

			// Show Message.
			const messageEl = document.querySelector( '.input_row_message.success_sent' );
			if ( messageEl ) {
				const EN_KO = window.EN_KO || {};
				EN_KO.functions.toggleDisplay( messageEl, true );
			}
		} ).catch( ( response ) => {
			const code = response.code;

			let errorType = 'unknown';
			if ( [ 400, 401 ].includes( code ) ) {
				if ( 'undefined' !== typeof response?.status ) {
					errorType = 'unknown';
				} else if ( response?.email ) {
					errorType = 'email';
				} else {
					errorType = 'session';
				}
			}

			// Show Message.
			const messageEl = this.formEl.querySelector( '.input_row_message[data-error-type="' + errorType + '"]' );
			showError( emailInputEl, messageEl?.innerHTML ?? false );
		} );
	}
}

TaoReady.ready( 'forms/friendinvite.js', function() {
	const formEl = document.getElementById( 'koe-friendinvite' );
	if ( formEl ) {
		formEl.KOE_FRIENDINVITE_FORM ??= new FriendinviteForm( formEl );
	}
} );
